/**
 * آیتم «وب اپلیکیشن ژومنت» در منوی فوتر (ویجت footer-menu) یک لینک معمولی
 * پنل است؛ این آدرس مشخص می‌کند که آیتم باید به‌جای لینک، مودال راهنمای نصب را باز کند.
 */
export const PWA_INSTALL_URL = "#pwa-install";

export const is_pwa_install_url = (url) =>
  typeof url === "string" && url.trim().toLowerCase() === PWA_INSTALL_URL;

export const PWA_PLATFORM = {
  IOS: "ios",
  ANDROID: "android",
};

/**
 * فقط روی گوشی‌های اندروید و iOS راهنما معنی دارد؛ برای بقیه‌ی دستگاه‌ها null.
 * آیپدهای جدید خودشان را «Macintosh» معرفی می‌کنند و فقط با تاچ قابل تشخیص‌اند.
 */
export const detect_pwa_platform = () => {
  if (typeof navigator === "undefined") return null;

  const ua = navigator.userAgent || "";

  if (/Android/i.test(ua)) return PWA_PLATFORM.ANDROID;

  const is_ipados_desktop_ua =
    navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1;

  if (/iPhone|iPad|iPod/i.test(ua) || is_ipados_desktop_ua) return PWA_PLATFORM.IOS;

  return null;
};

/** وقتی سایت از روی صفحه‌ی اصلی گوشی باز شده، دیگر نیازی به راهنما نیست. */
export const is_running_standalone = () => {
  if (typeof window === "undefined") return false;

  return (
    window.matchMedia?.("(display-mode: standalone)").matches ||
    window.navigator.standalone === true
  );
};
